/* Zauberzwerge: required customer details for native forms and accessory add-ons. */
(function(){
 if(window.__zzCroPersonalizationV3) return;
 window.__zzCroPersonalizationV3=true;
 function getChoice(root){
   var variantSelect=root.closest('form')?.querySelector('select[name="id"]');
   if(root.dataset.zzKind==='addon' && variantSelect){
     var opt=variantSelect.options[variantSelect.selectedIndex];
     if(!opt || !opt.value) return '';
     return (opt.parentElement?.label||'')+' '+opt.textContent;
   }
   var productInfo=root.closest('product-info');
   var variantPicker=productInfo?.querySelector('variant-selects');
   if(!variantPicker)return '';
   var wanted=(root.dataset.zzOption||'').trim().toLowerCase();
   var selects=variantPicker.querySelectorAll('select[name^="options["]');
   for(var i=0;i<selects.length;i++){
      var sel=selects[i];
      var name=sel.getAttribute('name').replace(/^options\[/,'').replace(/\]$/,'').trim().toLowerCase();
      if(name===wanted)return sel.value||'';
   }
   var radios=variantPicker.querySelectorAll('fieldset');
   for(var j=0;j<radios.length;j++){
      var field=radios[j];
      if(field.querySelector('legend')?.textContent.trim().toLowerCase()!==wanted)continue;
      return field.querySelector('input[type="radio"]:checked')?.value||'';
   }
   return '';
 }
 function numberOfNames(value){
   if(!value)return 0;
   if(/ohne\s+(namen|name|namensbestickung|gesticktem namen)/i.test(value))return 0;
   var x=value.match(/mit\s+(\d+)\s+namen/i);
   if(x)return Math.min(6,parseInt(x[1],10));
   if(/mit\s+(gesticktem\s+)?name/i.test(value) || /\bname\s+und\b/i.test(value) || /^name$/i.test(value.trim()))return 1;
   return 0;
 }
 function sync(root){
   var mode=root.dataset.zzMode;
   if(mode!=='named_variant' && mode!=='named_variant_motif')return;
   var choice=getChoice(root);
   var count=numberOfNames(choice);
   root.hidden=(count===0);
   root.querySelectorAll('[data-zz-name-row]').forEach(function(row){
      var index=Number(row.dataset.zzNameRow);
      var active=index<=count;
      var field=row.querySelector('input');
      row.hidden=!active;
      field.disabled=!active;
      field.required=active;
      if(!active)field.setCustomValidity('');
   });
   var motifRow=root.querySelector('[data-zz-motif-row]');
   if(motifRow){
     var active=count>0 && /stickbild/i.test(choice);
     motifRow.hidden=!active;
     var field=motifRow.querySelector('input');
     field.disabled=!active;
     field.required=active;
     if(!active)field.setCustomValidity('');
   }
 }
 function syncAll(scope){
   (scope||document).querySelectorAll('[data-zz-personalization]').forEach(sync);
 }
 document.addEventListener('change',function(ev){
   if(!ev.target.matches('variant-selects select, variant-selects input, [data-zz-personalization] select, select[name="id"]'))return;
   var scope=ev.target.closest('product-info')||ev.target.closest('.zz-cro--after')||document;
   syncAll(scope);
 },true);
 document.addEventListener('input',function(ev){
   var x=ev.target;
   if(x.matches('[data-zz-required]'))x.setCustomValidity('');
 },true);
 document.addEventListener('submit',function(ev){
   var form=ev.target;
   if(!form||!form.querySelectorAll)return;
   form.querySelectorAll('[data-zz-personalization]').forEach(sync);
   var fields=form.querySelectorAll('[data-zz-required]:not(:disabled)');
   for(var i=0;i<fields.length;i++){
     var field=fields[i];
     if(field.required && !field.value.trim()){
       field.setCustomValidity('Bitte dieses Feld ausfüllen.');
       field.reportValidity();
       field.focus();
       ev.preventDefault();
       ev.stopImmediatePropagation();
       return;
     }
     field.setCustomValidity('');
   }
   var variant=form.querySelector('select[name="id"]');
   if(variant && !variant.value){
     variant.reportValidity();
     variant.focus();
     ev.preventDefault();
     ev.stopImmediatePropagation();
   }
 },true);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){syncAll(document);});
 else syncAll(document);
 document.addEventListener('shopify:section:load',function(ev){syncAll(ev.target);});
})();
